import { FC } from 'react'

import { FF, FormType, RadioGroup, Select, TextareaInput } from 'ui/components'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import { QuestionnaireDemo } from '../../../../../../types'
import * as SC from '../../../../style'

export const CheckDebits: FC<{ formApi: FormType<QuestionnaireDemo> }> = ({ formApi }) => {
  return (
    <>
      <FormRow>
        <Col>
          <SC.SecondText>Review all Check Debits for payments out-of-state and/or suspicious merchants</SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="checkDebitsOutsideSuspiciousReview"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo valueType="boolean" {...p} />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <formApi.Field
            name="checkDebitsOutsideSuspiciousAddressed"
            children={(field) => (
              <FF
                field={field}
                label="If noted, how was the activity addressed?"
                input={(p) => (
                  <Select
                    data={[
                      {
                        label: 'N/A',
                        value: 'n/a'
                      },
                      {
                        label: 'Transaction cleared with communication to customer during review',
                        value: 'cleared'
                      },
                      {
                        label: 'Transaction added to annual questions',
                        value: 'added'
                      }
                    ]}
                    {...p}
                  />
                )}
              />
            )}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col2x>
          <formApi.Field
            name="checkDebitsOutsideSuspiciousComments"
            children={(field) => (
              <FF field={field} label="Comments" input={(p) => <TextareaInput maxLength={5000} {...p} />} />
            )}
          />
        </Col2x>
      </FormRow>
    </>
  )
}
